module.exports = {
  // appKey: 'epicseven',
  appKey: 'A17DyecjD2Dit4isN37EuDSciR1oDcR1',
  iv: '1iSD35Sah2RduEcg',
  algorithm: 'aes-256-ctr',
};
